export default function () {
  if ($(".js-jump-bar-scroll").length > 0) {
    $(window).on("activate.bs.scrollspy", function () {
      // START VARIABLE SETUP
      let halfViewportWidth = $(".js-jump-bar-scroll").width() / 2;

      let distanceToActiveLeftEdge =
        $(".js-jump-bar .active").position().left - 10;

      let activeWidth = $(".js-jump-bar .active").outerWidth();

      let distanceToActiveElementCenter =
        distanceToActiveLeftEdge + activeWidth / 2;
      let scrollAmount = distanceToActiveElementCenter - halfViewportWidth;
      // END VARIABLE SETUP

      // WHERE THE MAGIC IS
      $(".js-jump-bar-scroll").scrollLeft(scrollAmount);
    });
  }
}
